import axios from 'axios';
import { supabase } from '../supabaseClient';
async function getProfessions() {
  const { data, error } = await supabase.from('Professions').select('*');
  if (data) return data;
  else throw error;
}
async function getNationality() {
  const { data, error } = await supabase.from('Nationality').select('*');
  if (data) return data;
  else throw error;
}
async function getNative() {
  const { data, error } = await supabase
    .from('Native')
    .select('*');
  if (data) return data;
  else throw error;
}
async function getNativeByName(name) {
  const { data, error } = await supabase
    .from('Native')
    .select('*')
    .ilike('native', `%${name}%`);
  if (data) return data;
  else throw error;
}
async function getBudget() {
  const { data, error } = await supabase
    .from('Budget')
    .select('*');
  if (data) return data;
  else throw error;
}
async function getBudgetByName(name) {
  const { data, error } = await supabase
    .from('Budget')
    .select('*')
    .ilike('budget', `%${name}%`);
  if (data) return data;
  else throw error;
}
async function getProjects() {
  let query;

  query = supabase
    .from('Projects')
    .select('*,Inventory!left(InventoryType(type))')
    .eq('isVJ', true);

  const { data, error } = await query
  if (data) return data;
  else throw error;
}
async function getProjectsForLeadFilter(typeOfAdmin, loggedInUserId, search) {
  let projectResults = [];
  let combinedProjectNames = [];

  const fetchProjectsFromTable = async (projectNames) => {
    let query = supabase
      .from("Projects")
      .select("*,Inventory!left(InventoryType(type))")
      .eq("isVJ", true);

    //If not super superadmin then search for only assigned projects here
    if (projectNames) {
      query = query.in("projectName", projectNames);
    }
    if (search !== null || search !== "" || search !== undefined) {
      query = query.ilike("projectName", `%${search}%`);
    }
    const { data, error } = await query;
    if (error) {
      throw error;
    }
    return data;
  };

  // JD / Landowner project names, so they are not added back as "missing" names below
  const fetchNonVJProjectNames = async () => {
    const { data, error } = await supabase
      .from("Projects")
      .select("projectName")
      .eq("isVJ", false);
    if (error) {
      throw error;
    }
    return data.map((proj) => proj.projectName);
  };

  const combineAndFilterProjects = (projectResults, combinedProjectNames, nonVJProjectNames) => {
    let foundProjectNames = projectResults.map((proj) => proj.projectName);

    let missingProjectNames = combinedProjectNames.filter(
      (name) => !foundProjectNames.includes(name) && !nonVJProjectNames.includes(name)
    );

    missingProjectNames.forEach((missingName) => {
      projectResults.push({
        projectName: missingName,
      });
    });

    if (search !== null || search !== "" || search !== undefined) {
      projectResults = projectResults.filter((project) =>
        project.projectName?.toLowerCase().includes(search.toLowerCase())
      );
    }
    return projectResults;
  };

  const nonVJProjectNames = await fetchNonVJProjectNames();

  if (typeOfAdmin === "Super Admin") {

    projectResults = await fetchProjectsFromTable();
    let allProjectNames = projectResults.map((proj) => proj.projectName);
    combinedProjectNames = await getAllUniqueProjects(allProjectNames, search);
    return combineAndFilterProjects(projectResults, combinedProjectNames, nonVJProjectNames);

  } else {

    let getAssignedProjectsData = await getAssignedProjects(loggedInUserId);
    let assignedProjectNames = getAssignedProjectsData.map(
      (project) => project.projectId.projectName
    );
    combinedProjectNames = await getAllUniqueProjects(assignedProjectNames, search);
    projectResults = await fetchProjectsFromTable(assignedProjectNames);
    return combineAndFilterProjects(projectResults, combinedProjectNames, nonVJProjectNames);
  }
}

async function getProjectsForLeads() {
  const { data, error } = await supabase
    .from('Projects')
    .select('*,Inventory!left(InventoryType(type))').eq('isVJ', true).eq('isPublished', true);
  if (data) return data;
  else throw error;
}
async function getAssignedProjectsForLeadPreference(userId) {
  const { data, error } = await supabase
    .from('SustenanceSalesRelations')
    .select('*,projectId(*,Inventory!left(InventoryType(type)))')
    .eq('projectId.isPublished', true)
    .eq('projectId.isVJ', true)
    .eq('userId', userId)
  if (data) return data;
  else throw error;
}
async function getProjectUnitType(projectId) {
  const { data, error } = await supabase.rpc('getuniqueunittypes', {
    pid: projectId,
  });
  if (data) return data;
  else throw error;
}
async function checkPersonExists(emailId) {
  const { data, error } = await supabase
    .from('Person')
    .select('*,Nationality(*),Professions(*),ProjectPreference(*)')
    .match({ email: emailId });
  if (data) return data;
  else throw error;
}
async function checkPhoneNumberExists(number) {
  const { data, error } = await supabase
    .from('Person')
    .select('*')
    .eq('contactNumber', number);
  if (data) return data;
  else throw error;
}
async function checkPhoneNumberIsBlackListed(number) {
  number = number.substring(1);
  const { data, error } = await supabase
    .from('BlacklistNumbers')
    .select('number')
    .eq('number', number);
  if (data) return data;
  else throw error;
}
async function addPersonTable(personalDetail, generalDetails) {
  const { data, error } = await supabase.from('Person').insert([
    {
      name: personalDetail.name.toUpperCase().replace(/\s\s+/g, ' '),
      contactNumber: personalDetail.phoneNumber,
      gender: personalDetail.gender,
      email: personalDetail.email,
      nationalityId: generalDetails.nationality,
      nativeId: generalDetails.native,
      professionId: generalDetails.worksIn,
      budgetId: generalDetails.budget,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function addLeadsTable(personId, userId, typeOfLead, personalDetail, referrerDetails, teamLeadRes, projectHead) {
  const { data, error } = await supabase
    .from('Leads')
    .insert([{
      personId: personId,
      leadType: typeOfLead,
      userId: userId,
      leadResponse: 'WARM', claimedById: userId,
      lastUpdatedById: userId,
      leadReferrerName: personalDetail.leadReferrerName,
      leadSubType: personalDetail.leadSubType,//roleName
      referrerDetails: referrerDetails,
      userParentId: teamLeadRes,
      projectHead: projectHead
    }])
  if (data) return data;
  else throw error;
}
async function addLeadStatus(leadId) {
  const { data, error } = await supabase
    .from('LeadStatus')
    .insert([{
      leadId: leadId, status: 'Claimed',
    }])
  if (data) return data;
  else throw error;
}

async function getLeadProjectPrefernce(personId) {
  const { data, error } = await supabase
    .from('Person')
    .select('*,ProjectPreference(*)')
    .order('last_updated_at', { ascending: false })
    .eq('personId', personId);
  if (data) return data;
  else throw error;
}
async function addProjectPrefernces(projectObject, personId) {
  const { data, error } = await supabase
    .from('ProjectPreference')
    .insert([{
      projectName: projectObject.selectedProject,
      unitType: projectObject.flatUnitType,
      // dateTime: projectObject.SitePrefernces,
      isPrimary: projectObject.isPrimary,
      personId: personId
    }])
  if (data) return data;
  else throw error;
}
async function updateProjectPrefernce(projectPreferenceId, isPrimary) {
  const { data, error } = await supabase
    .from('ProjectPreference')
    .update({ isPrimary: isPrimary, last_updated_at: Date.now() })
    .eq('projectPreferenceId', projectPreferenceId);
  if (data) return data;
  else throw error;
}
async function addKYCDoc(leadId, docNumber, docHolderName, panObject, docType) {
  const { data, error } = await supabase.from('KycDocuments').insert([
    {
      leadId: leadId,
      docType: docType,
      docNumber: docNumber,
      docHolderName: docHolderName,
      docUrl: '',
      otherDetails: panObject,
    },
  ]);
  if (data) return data;
  else throw error;
}
async function getUsers(search, loggedInUser, teamIds) {
  let query;
  if (loggedInUser?.roleId?.level !== 1) {
    query = supabase.from('Users')
      .select('*', { count: 'exact' })
      .in('userId', teamIds);
  } else {
    query = supabase.from("Users").select("*", { count: "exact" });
  }
  if (search !== null && search !== "" && search !== undefined) {
    query = query.ilike("name", `%${search}%`);
  }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getUsersForTeamLead(userId) {
  const { data, error } = await supabase.from('Users')
    .select('*')
    .eq('userId', userId);
  if (data) return data;
  else throw error;
}
async function getLeads(from, to, sendTabValue) {
  // console.log(sendTabValue);
  const filters = {
    "Unclaimed": {
      key: 'status',
      val: ['Unclaimed']
    },
    "Nuturing": {
      key: 'status',
      val: ['Claimed', 'Site Visit Scheduled', 'Site Visit Pending']
    },
    "Site Visit": {
      key: 'status',
      val: ['Site Visit Done']
    },
    "Token": {
      key: 'status',
      val: ['Token Payment Pending', 'Token Partial Payment Done', 'Token Payment Complete']
    },
    "Allotment": {
      key: 'status',
      val: ['Allotment Done', 'Unit On Hold', 'Allotment Partial Payment Done']
    },
    "Closed": {
      key: 'status',
      val: ['closed']
    },
    "All": {
      key: 'status',
      val: 'null'
    }
  }
  var query;
  if (sendTabValue === 'Unclaimed') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .eq('status', sendTabValue)
      .order('last_updated_at', { ascending: false })
      .range(from, to));
  } else if (sendTabValue === 'Nuturing') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .in('status', ['Claimed', 'Site Visit Scheduled', 'Site Visit Pending',])
      .order('last_updated_at', { ascending: false })
      .range(from, to));
  } else if (sendTabValue === 'Site Visit') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .in('status', ['Site Visit Done']).order('last_updated_at', { ascending: false }).range(from, to));
  } else if (sendTabValue === 'Token') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .in('status', ['Token Payment Pending', 'Token Partial Payment Done', 'Token Payment Complete', 'Token Refund Requested', 'Token Refunded', 'Token Refund Request Rejected']).order('last_updated_at', { ascending: false }).range(from, to));
  } else if (sendTabValue === 'Allotment') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .in('status', ['Allotment Done', 'Unit On Hold', 'Allotment Partial Payment Done']).order('last_updated_at', { ascending: false }).range(from, to));
  } else if (sendTabValue === 'Closed') {
    query = await (await supabase.from('LeadStatus')
      .select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' })
      .in('status', ['closed']).range(from, to));
  } else {
    query = await (await supabase.from('LeadStatus').select(`*,leadId(*,FOS(*),CP(*),userId(*),personId(*,ProjectPreference!left(*)))`, { count: 'exact' }).range(from, to));
  }
  const { data, error, count } = query
  if (data) return { data, count };
  else throw error;

}
async function getLeadsFromRpc(
  from,
  to,
  sendTabValue,
  search,
  drpDownSelectedVal,
  selectDates,
  selectedDates,
  selectedCP,
  selectedSales,
  selectedProjects,
  selectedLeadQuality,
  selectedStatus,
  loggedInUserId,
  typeOfAdmin,
  loggedInUser,
  selectedLeadType
) {
  const filters = {
    "Name Ascending": {
      key: 'leadname',
      isAscending: true
    },
    "Name Descending": {
      key: 'leadname',
      isAscending: false
    },
    "Oldest First": {
      key: 'statuschangeddate',
      isAscending: true
    },
    "Latest First": {
      key: 'statuschangeddate',
      isAscending: false
    }
  }
  //let loggedInUser = localStorage.getItem("user")
  var query;
query = supabase.rpc(
  'leadsfilter_matchmaking',
  { p_user_id: loggedInUserId },
  { count: 'exact' }
)
  .order('leadfinalscore', { ascending: false, nullsFirst: false })  // 👈 PRIMARY: scores first
  .order('last_updated_at', { ascending: false })                     // 👈 SECONDARY: recency
  .range(from, to)

  //user loggedIn type
  if (sendTabValue === 'Unclaimed') {
    query = query.eq('leadstatus', sendTabValue)
    const payload = [];
    // Direct
    if (loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.["Accessible Leads"]?.["Direct"]) {
      payload.push("Direct")
    }
    //CP
    if (loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.["Accessible Leads"]?.["CP"]) {
      payload.push("CP")
    }
    //R&L
    if (loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.["Accessible Leads"]?.["R&L"]) {
      payload.push("R&L")
    }
    query = query.in("leadtype", payload);
  }
  else if (sendTabValue === 'Nuturing') {
    query = query.in('leadstatus', ['Claimed', 'Site Visit Scheduled', 'Site Visit Pending',])

  } else if (sendTabValue === 'Site Visit') {
    query = query
      .in('leadstatus', ['Site Visit Done'])
  } else if (sendTabValue === 'Token') {
    query = query
      .in('leadstatus', ['Token Payment Pending', 'Token Partial Payment Done', 'Token Payment Complete', 'Checkpoint One Cleared', 'Checkpoint Two Cleared', 'Token Refund Requested', 'Token Refunded', 'Token Refund Request Rejected', 'Token Payment Not Done'])
  } else if (sendTabValue === 'Allotment') {
    query = query
      .in('leadstatus', ['Allotment Done', 'Unit On Hold', 'Allotment Partial Payment Done', 'Allotment Payment Pending', 'Allotment Payment Complete', 'PreSelect Confirmation Pending', 'PreSelect Price Confirmation Pending', 'PreSelect Unit On Hold', 'PreSelect Payment Pending', 'Preselect not confirmed', 'PreSelect Partial Payment Done', 'Preselect payment not done', 'Unit On Hold', 'Change Unit Requested', 'Change Unit Confirmation Pending', 'Change Unit Confirmation Rejected', 'Change Unit Confirmed', 'Change Unit Rejected', 'Cancellation Confirmation Pending', 'Cancel Unit Rejected', 'Cancel Unit Confirmation Rejected', 'Cancellation Done', 'Cancellation Pending', 'Cancellation Not Done', 'Payment Pending', 'Unit Change Requested', 'Allotment Refunded']);

  } else if (sendTabValue === 'Agreement Done') {
    query = query.in('leadstatus', ['Agreement Done']).range(from, to);
  }
  if (search !== null || search !== '' || search !== undefined) {
    search = search.replace(/\s\s+/g, ' ')
    query = query.ilike('leadname', `%${search}%`);
  }
  if (selectedSales.length !== 0) {
    // console.log(selectedSales);
    query = query.in('salesid', selectedSales);
  }
  if (selectedProjects.length !== 0) {
    // console.log(selectedProjects);
    query = query.in('projectname', selectedProjects);
  }
  if (selectedStatus.length !== 0) {
    // console.log(selectedSales);
    query = query.in('leadstatus', selectedStatus);
  }
  if (selectedLeadQuality.length !== 0) {
    query = query.in('leadresponse', selectedLeadQuality);
  }
  if (selectedLeadType?.length !== 0) {
    query = query.in("leadtype", selectedLeadType)
  }
  if (selectedCP.length !== 0) {
    query = query.in('cpid', selectedCP);
  }
  if (selectedDates !== null) {
    // console.log(selectedDates);
    query = query.gte('created_at', new Date(selectDates[0].value).getTime()).lte('created_at', new Date(selectDates[1].value).getTime());
  }
  // ??check userId condition only except Unclaimed
  // !!Added new condition if some user is not superAdmin but has to give access to see all leads 
  if (typeOfAdmin !== 'Super Admin' && JSON.parse(localStorage.getItem('user'))?.roleId?.accessibleTabs?.Leads["Show Leads"]?.show !== 'All') {
    if (sendTabValue !== 'Unclaimed') {
      // ! vedashree changes
      const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      query = query.in('salesid', teamIds);
      // query = query.eq('salesid', loggedInUserId);
    } else {
      // **For Unclaimed tab other users to show only respective projects
      let getAssignedProjectsData = await getAssignedProjects(loggedInUserId);
      // console.log({ getAssignedProjectsData })
      let assignedProjectNames = [];
      getAssignedProjectsData.forEach((project) => {
        assignedProjectNames.push(project.projectId.projectName);
      });
      // console.log({ assignedProjectNames })
      query = query.in('projectname', assignedProjectNames)
    }
  }
  const { data, count, error } = await query
  if (data) return { data, count };
  else throw error;
}

async function getAssignedProjects(loggedInUserId) {
  const { data, error } = await supabase.from('SustenanceSalesRelations')
    .select('*,projectId(*)')
    .eq('userId', loggedInUserId)
  if (data) return data;
  else throw error;
}
async function updateLeadForClaim(leadId, userId, teamLeadRes) {
  const { data, error } = await supabase
    .from('Leads')
    .update({
      claimedById: userId,
      lastUpdatedById: userId,
      userId: userId,
      userParentId: teamLeadRes,
      last_updated_at: Date.now(),
    })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
async function updateLeadStatus(leadId) {
  const { data, error } = await supabase
    .from('LeadStatus')
    .update({ status: 'Claimed', last_updated_at: Date.now() })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
//leadResponse
async function updateLeadResponse(leadId, leadResponse) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ leadResponse: leadResponse, last_updated_at: Date.now() })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}

//update lead's virtual account details after recreating account
async function updateLeadVirtualAccountDetails(leadId, virtualAccId, virtualAccDetails) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ virtualAccId: virtualAccId, virtualAccDetails: virtualAccDetails, last_updated_at: Date.now() })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}

//getLeadStatus for UpdateLeadModal
async function getLeadStatus(leadId) {
  const { data, error } = await supabase
    .from('LeadStatus')
    .select('*')
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
//reAssign Lead
async function reAssignLead(leadId, userId, teamLeadRes) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ userId: userId, last_updated_at: Date.now(), userParentId: teamLeadRes })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
async function checkForUniqueDocs(docNumber) {
  const { data, error } = await supabase
    .from('KycDocuments')
    .select('*')
    .eq('docNumber', docNumber)
    .is('leadId', null);
  if (data) return data;
  else throw error;
}
//leadStatus Update
async function updateLeadAllStatus(leadId, status) {
  const { data, error } = await supabase
    .from('LeadStatus')
    .update({ status: status, last_updated_at: Date.now() })
    .eq('leadId', leadId).single();
  if (data) return data;
  else throw error;
}

async function leadLogsInsertQuery(userId, fosId, cpId, leadId, Reason, message) {
  const { data, error } = await supabase.from('LeadLogs').insert([
    {
      userId: userId,
      fosId: fosId,
      cpId: cpId,
      leadId: leadId,
      leadStatus: "Churned",
      Reason: Reason,
      message: message
    },
  ]);
  if (data) return data;
  else throw error;
}
async function updateChurnLeadData(leadId) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ cpId: null, fosId: null, userId: null, last_updated_at: Date.now(), leadType: 'Direct', claimedById: null })
    .eq('leadId', leadId).single();
  if (data) return data;
  else throw error;
}
//On churn lead

async function checkLeadExistInSiteVisit(leadId) {
  const { data, error } = await supabase
    .from('SiteVisit')
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
async function deleteSiteVisitData(leadId) {
  const { data, error } = await supabase
    .from('SiteVisit')
    .delete()
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}
async function updatePersonTable(name, personId) {
  const { data, error } = await supabase
    .from('Person')
    .update({ name: name })
    .eq('personId', personId);
  if (data) return data;
  else throw error;
}
async function addLeadLogs(obj) {
  const { data, error } = await supabase
    .from('LeadLogs')
    .insert([{
      ...obj
    }])
  if (data) return data;
  else throw error;
}

async function addLeadsReferralTable(obj) {
  const { data, error } = await supabase
    .from('LeadsReferral')
    .insert([{
      ...obj
    }])
  if (data) return data;
  else throw error;
}
async function getAllTokenLeadReport() {
  const { data, error } = await supabase.from('EventTokenLeadRelations').select('*, eventTokenId(tokenId(name)), leadId(personId(name), userId(name), cpId(billingName), fosId(name)), eventId(title)').limit(10)
  if (data) return data;
  else throw error;
}
async function getAllLeadAllotmentReport() {
  const { data, error } = await supabase.from('AllotmentPayment').select('*, unitId(*,projectId(projectName), wingId(wingName)), leadId(personId(name), userId(name), cpId(billingName), fosId(name)), userId(name)').limit(10)
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExists(email) {
  const { data, error } = await supabase
    .from('Person')
    .select('email')
    .eq('email', email);
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExistsInUsers(email) {
  const { data, error } = await supabase
    .from('Users')
    .select('email')
    .eq('email', email);
  if (data) return data;
  else throw error;
}
async function checkLeadEmailExistsInCp(email) {
  const { data, error } = await supabase
    .from('CpContactPerson')
    .select('email')
    .eq('email', email);
  if (data) return data;
  else throw error;
}
async function addLeadNotificationForCp(obj) {
  const { data, error } = await supabase.from('LeadNotificationsForCp').insert([{ ...obj }]);
  if (data) return data;
  else throw error;
}

async function updateLeadPersonTable(personId, obj) {
  const { data, error } = await supabase
    .from('Person')
    .update(obj)
    .eq('personId', personId);
  if (data) return data;
  else throw error;
}

async function updateLeadLoginTable(CUID, obj) {
  const { data, error } = await supabase
    .from('LeadLogin')
    .update(obj)
    .eq('CUID', CUID);
  if (data) return data;
  else throw error;
}

async function getVirtualAccountStatus(razorpayCustomerId, leadId) {
  const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'payments/recreate-virtual-acc',
    {
      razorpayCustomerId: razorpayCustomerId,
      leadId: leadId
    })
  return response;
}


async function getLeadVirtualAccountStatus(body) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'payments/getVirtualAccStatus', body).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err)
    })
  })
}

async function checkLeadSiteVisitAndProjects(payload) {
  let query = supabase.from("SiteVisits").select("*").eq("leadId", payload.leadId).order("created_at", { ascending: false });
  if (payload.projects) {
    query = query.in("projectId", payload.projects);
  }
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function getLaunchesProjects(eventId) {
  const { data, error } = await supabase.from("Launches").select('*').eq("eventId", eventId);
  if (data) return data;
  else throw error;
}

async function getAllUniqueProjects(assignedProjectNames, search) {
  const { data, error } = await supabase
    .from("Leads")
    .select("personId")
    .eq("leadType", "R&L")
  if (data) {
    const personIds = data.map((val) => val?.personId)
    const response = await getProjectNameFromProjectPref(personIds);
    if (response) {
      const projectPreferenceNames = response.map((data) => data.projectName);
      let combinedProjectNames = [...projectPreferenceNames, ...assignedProjectNames];
      let uniqueCombinedProjectNames = [...new Set(combinedProjectNames)];
      return uniqueCombinedProjectNames;
    } else {
      return error;
    }
  } else {
    return error;
  }
}

// async function getProjectNameFromProjectPref(personIds, search) {
//   let query = supabase
//                 .from("ProjectPreference")
//                 .select("projectName")  
//                 .in("personId", personIds)

//   // if (search !== null || search !== "" || search !== undefined) {
//   //   query = query.ilike("projectName", `%${search}%`);
//   // }              
//   const { data, error } = await query
//   if(data) return data;
//   else return error;
// }

async function getProjectNameFromProjectPref(personIds) {
  const batchSize = 100;
  let allResults = [];
  for (let i = 0; i < personIds.length; i += batchSize) {
    const chunk = personIds.slice(i, i + batchSize);

    const query = supabase
      .from("ProjectPreference")
      .select("projectName")
      .in("personId", chunk);

    try {
      const { data, error } = await query;

      if (error) {
        console.error(`Error in batch ${i / batchSize + 1}:`, error);
        continue;
      }
      if (data) {
        allResults = allResults.concat(data);
      }
    } catch (err) {
      console.error(`Unexpected error in batch ${i / batchSize + 1}:`, err);
    }
  }

  // console.log("allResults", allResults);
  return allResults;
}

async function sendWhatsappMessageOnLeadClaimed(leadName, contactNumber, projectDetails, salesManagerName) {
  return await axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}whatsapp/sendWaMsgOnLeadClaimed`, {
    // return await axios.post(`http://localhost:8053/whatsapp/sendWaMsgOnLeadClaimed`, {
    leadName,
    contactNumber,
    projectDetails,
    salesManagerName
  });
}

async function sendWhatsappMessageOnAssignToken(leadName, contactNumber) {
  return await axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}whatsapp/sendWaMsgOnAssignNewToken`, {
    // return await axios.post(`http://localhost:8053/whatsapp/sendWaMsgOnAssignNewToken`, {
    leadName,
    contactNumber
  });
}

async function sendWhatsappMessageOnSiteVisitDone(postBody) {
  return await axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}whatsapp/whatsappMsgOnSiteVisitDone`, postBody)
  // return await axios.post(`http://localhost:8053/whatsapp/whatsappMsgOnSiteVisitDone`, postBody);
}

async function sendWhatsappMessageOnLeadRegisteredDirect(contactNumber, leadName, cuid) {
  return await axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}whatsapp/sendWaMsgOnLeadRegisteredDirect`, {
    // return await axios.post(`http://localhost:8053/whatsapp/sendWaMsgOnLeadRegisteredDirect`, {
    contactNumber, leadName, cuid
  });
}

async function getCUID(leadId) {
  const { data, error } = await supabase
    .from("Leads")
    .select("leadDisplayId")
    .eq("leadId", leadId)

  if (data) return data;
  else return error;
}

async function reAssignMultipleLeads(leadIds, userId, teamLeadRes) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ userId: userId, last_updated_at: Date.now(), userParentId: teamLeadRes })
    .in('leadId', leadIds);
  if (data) return data;
  else throw error;
}

async function updateMultipleLeadForClaim(leadIds, userId, teamLeadRes) {
  const { data, error } = await supabase
    .from('Leads')
    .update({
      claimedById: userId,
      lastUpdatedById: userId,
      userId: userId,
      userParentId: teamLeadRes,
      last_updated_at: Date.now(),
    })
    .in('leadId', leadIds);
  if (data) return data;
  else throw error;
}

async function updateMultipleLeadStatus(leadIds) {
  const { data, error } = await supabase
    .from('LeadStatus')
    .update({ status: 'Claimed', last_updated_at: Date.now() })
    .in('leadId', leadIds);
  if (data) return data;
  else throw error;
}

async function addMultipleLeadLogs(leadsArray) {
  const { data, error } = await supabase
    .from('LeadLogs')
    .insert(leadsArray)
  if (data) return data;
  else throw error;
}

async function getProjectsData() {
  const response = await axios.get(process.env.REACT_APP_PAYMENT_LINK_URL + 'units/fetchProjectsData',)
  // const response = await axios.get('http://localhost:8050/units/fetchProjectsData',)

  return response;
}

async function getAllWingsByProjectIdPre(projectId) {
  const { data, error } = await supabase
    .from("ProjectInventoryRelations")
    .select("projectInventoryRelationId,wingId,wingId(wingId,wingName,displayName,projectId)")
    .eq("projectId", projectId);
  if (data) return { data};
  else throw error;
}
async function getProjectsDataPre() {
  let query;
  query = supabase
    .from("Projects")
    .select("projectName,projectId,isPublished")
    .eq('isPublished', true)
    .eq('isVJ', true)
    .order("projectName", {
      ascending: true
    })

  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function getAllUnitsByProjectIdWingsId(projectId,wingId) {
  const { data, error, count } = await supabase
     .from("ProjectInventoryRelations")
     .select(
       "*  , unitId(unitId,unitNo,floorNo,inventoryStatusId(*) ) , wingId(*)",
       { count: "exact" }
     )
     .eq("projectId", projectId)
     .eq("wingId", wingId);
  if (data) return { data, count };
  else throw error;
}

async function getPersonFromAllotmentPayment(unitId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("leadId,status") 
    .eq("unitId", unitId);
  if (data) return { data };
  else throw error;
}


async function getPersonFromAllotmentPaymentbybookingId(bookingId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("leadId,status")
    .eq("bookingId", bookingId);
  if (data) return { data };
  else throw error;
}

async function updateLeadCpId(leadId, cpId, fosId, leadType) {
  const { data, error } = await supabase
    .from('Leads')
    .update({ cpId: cpId, fosId: fosId || null, leadType: leadType, last_updated_at: Date.now() })
    .eq('leadId', leadId);
  if (data) return data;
  else throw error;
}

async function checkLeadHasApplicationApiRes(leadId) {
  const { data, error } = await supabase
    .from('AllotmentPayment')
    .select('applicationApiRes, bookingId')
    .eq('leadId', leadId)
    .or('applicationApiRes.not.is.null,bookingId.not.is.null')
    .limit(1);
  if (error) throw error;
  return data && data.length > 0;
}

/**
 * Allotment/booking/unit details needed to run the Lead Source Change flow's
 * CP payment gate and Farvision broker-change call. Returns null if the lead
 * has no AllotmentPayment row (nothing to gate/sync against).
 */
async function getAllotmentDetailsForLeadSourceChange(leadId) {
  const { data, error } = await supabase
    .from('AllotmentPayment')
    .select(`
      allotmentPaymentId, bookingId, unitCost, status, isCrm2,
      unitId(unitId, unitNo, farvisionUnitId, wingId(wingId, wingName), projectId(projectId, projectName, buId))
    `)
    .eq('leadId', leadId)
    .limit(1)
    .maybeSingle();
  // maybeSingle() is supposed to return {data:null, error:null} for zero
  // matching rows, but this project's supabase-js v1 client instead throws
  // PGRST116 ("...no rows returned") for that case too. The .limit(1) above
  // makes the "multiple rows" variant of that same code structurally
  // impossible here, so any PGRST116 in this function specifically means
  // "no allotment yet" (data stays null), not a real fetch failure.
  if (error && error.code !== 'PGRST116') throw error;
  if (!data) return null;

  return {
    allotmentPaymentId: data.allotmentPaymentId,
    bookingId: data.bookingId,
    status: data.status,
    unitId: data.unitId?.unitId ?? null,
    unitNo: data.unitId?.unitNo ?? null,
    farvisionUnitId: data.unitId?.farvisionUnitId ?? null,
    wingId: data.unitId?.wingId?.wingId ?? null,
    wingName: data.unitId?.wingId?.wingName ?? null,
    projectId: data.unitId?.projectId?.projectId ?? null,
    projectName: data.unitId?.projectId?.projectName ?? null,
    buId: data.unitId?.projectId?.buId ?? null,
    agreementValue: Number(data.unitCost?.total) || 0,
    unitCost: data.unitCost || {},
  };
}

/**
 * Lead identity fields needed to create a brand-new fos_leads row when a
 * FOS is assigned for the first time (Lead Source Change Direct/CP → FOS).
 */
async function getLeadDetailsForFosWalletAssignment(leadId) {
  const { data, error } = await supabase
    .from('Leads')
    .select('leadId, leadDisplayId, personId(name, contactNumber, email)')
    .eq('leadId', leadId)
    .maybeSingle();
  if (error) throw error;
  if (!data) return null;

  return {
    name: data.personId?.name || '',
    mobile: data.personId?.contactNumber || '',
    email: data.personId?.email || '',
    sales_app_lead_display_id: data.leadDisplayId || null,
  };
}

async function getLeadData(leadId) {
  const { data, error } = await supabase
  .from("Leads")
  .select("personId,leadType")
  .eq("leadId", leadId);
  if (data) return { data};
  else throw error;
}

async function getLeadPersonData(personId) {
  const { data, error } = await supabase
    .from("Person")
    .select("name, contactNumber")
    .eq("personId", personId);
  if (data) return { data };
  else throw error;
}

async function getCustomerDetails(project, wing, unit) {
  // const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}units/fetchCustomerDetails?project=${project}&wing=${wing}&unit=${unit}`;
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}units/fetchCustomerDetails?project=${encodeURIComponent(project)}&wing=${encodeURIComponent(wing)}&unit=${encodeURIComponent(unit)}`
  // const url = `http://localhost:8050/units/fetchCustomerDetails?project=${project}&wing=${wing}&unit=${unit}`;
  
  const response = await axios.get(url)
  return response;
}

async function addLead(payload) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}units/addLead`;
  // const url = `http://localhost:8050/units/addLead`;
  return new Promise((resolve, reject) => {
    axios.post(url, payload).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err)
    })
  })
}

// --- Lead Regeneration & Recovery (backend REST endpoints) ---
// Lost leads are normal leads with LeadStatus.status = 'Lost'. The backend
// returns them contact-masked (no mobile/email), filtered/sorted/paginated.
// `filters` (all optional): { search, sort, projects[], salesIds[], cpIds[],
// leadTypes[], leadResponses[], dateFrom, dateTo }. Arrays are JSON-encoded.
async function getLostLeads(page = 1, pageSize = 50, filters = {}) {
  const p = new URLSearchParams();
  p.set("page", page);
  p.set("pageSize", pageSize);
  if (filters.search) p.set("search", filters.search);
  if (filters.sort) p.set("sort", filters.sort);
  if (filters.dateFrom) p.set("dateFrom", filters.dateFrom);
  if (filters.dateTo) p.set("dateTo", filters.dateTo);
  const arr = (key, val) => {
    if (Array.isArray(val) && val.length) p.set(key, JSON.stringify(val));
  };
  arr("projects", filters.projects);
  arr("salesIds", filters.salesIds);
  arr("cpIds", filters.cpIds);
  arr("leadTypes", filters.leadTypes);
  arr("leadResponses", filters.leadResponses);
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadRegeneration/lostLeads?${p.toString()}`;
  const response = await axios.get(url);
  return response.data; // { success, total, page, pageSize, data: [...] }
}

// Regenerate a fresh Direct lead from a Lost lead, assigned to the acting manager.
// payload: { leadId, projectName, userId, unitType? }
async function regenerateLead(payload) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadRegeneration/regenerate`;
  const response = await axios.post(url, payload);
  return response.data; // { success, message, leadId, leadDisplayId }
}

// --- Regeneration Settings: stage-rule CRUD (admin) ---
async function getExpiryRules() {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadExpirySettings/rules`;
  const response = await axios.get(url);
  return response.data; // { success, data: [...] }
}
async function createExpiryRule(payload) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadExpirySettings/rules`;
  const response = await axios.post(url, payload);
  return response.data;
}
async function updateExpiryRule(id, patch) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadExpirySettings/rules/${id}`;
  const response = await axios.patch(url, patch);
  return response.data;
}
async function deleteExpiryRule(id) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadExpirySettings/rules/${id}`;
  const response = await axios.delete(url);
  return response.data;
}
async function getExpiryProtectedStatuses() {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}leadExpirySettings/protected`;
  const response = await axios.get(url);
  return response.data;
}

// A Cancellation/Unit Shift approval reassigned via Work Transfer never
// updates the lead card's status chip — that text comes straight from the
// leadsfilter RPC's leadstatus field, frozen with the ORIGINAL approver's
// name at request-creation time (rewriting the RPC itself is out of scope —
// its definition isn't tracked in this repo and it's used everywhere).
// This patches just the leads currently showing that frozen "...Confirmation
// Pending by X" text with the latest matching LeadLogs.leadStatus, if a
// newer Work Transfer approval-reassignment entry exists for that lead — one
// batched query for the whole list, not per-card, and every other lead's
// status is left untouched.
const APPROVAL_REASSIGN_STATUSES = [
  'Cancellation approval Reassigned',
  'Unit shift approval Reassigned',
  'Site visit approval Reassigned',
];
async function overrideStaleApprovalStatuses(leads) {
  const staleLeads = (leads || []).filter((l) => /Confirmation Pending by/i.test(l?.status || ''));
  if (staleLeads.length === 0) return leads;
  const leadIds = staleLeads.map((l) => l.leadId).filter(Boolean);
  if (leadIds.length === 0) return leads;
  const { data, error } = await supabase
    .from('LeadLogs')
    .select('leadId, leadStatus, created_at')
    .in('leadId', leadIds)
    .in('leadStatus', APPROVAL_REASSIGN_STATUSES)
    .order('created_at', { ascending: false });
  if (error || !data || data.length === 0) return leads;
  const latestByLeadId = new Map();
  for (const row of data) {
    if (!latestByLeadId.has(row.leadId)) latestByLeadId.set(row.leadId, row.leadStatus);
  }
  return leads.map((l) => (latestByLeadId.has(l.leadId) ? { ...l, status: latestByLeadId.get(l.leadId) } : l));
}

export {
  getProfessions, getNationality, getProjects, checkPersonExists, addPersonTable,
  addLeadsTable, addLeadStatus, addKYCDoc, getLeads, getProjectUnitType, getLeadProjectPrefernce, addProjectPrefernces,
  updateProjectPrefernce, getUsers, updateLeadStatus, updateLeadForClaim, updateLeadResponse,
  checkPhoneNumberIsBlackListed, checkPhoneNumberExists, getLeadStatus, reAssignLead, checkForUniqueDocs,
  leadLogsInsertQuery, updateLeadAllStatus, updateChurnLeadData, deleteSiteVisitData, checkLeadExistInSiteVisit,
  getNative, getNativeByName, getBudget, getBudgetByName,
  getLeadsFromRpc, updatePersonTable, addLeadLogs,
  getProjectsForLeads, getUsersForTeamLead, getProjectsForLeadFilter,
  checkLeadEmailExists, checkLeadEmailExistsInUsers, checkLeadEmailExistsInCp, addLeadNotificationForCp, updateLeadPersonTable, updateLeadLoginTable,
  getAssignedProjectsForLeadPreference, getVirtualAccountStatus, getLeadVirtualAccountStatus, updateLeadVirtualAccountDetails, checkLeadSiteVisitAndProjects, getLaunchesProjects, getAllUniqueProjects, getProjectNameFromProjectPref,
  sendWhatsappMessageOnLeadClaimed, sendWhatsappMessageOnAssignToken, sendWhatsappMessageOnSiteVisitDone, sendWhatsappMessageOnLeadRegisteredDirect, getCUID,
  reAssignMultipleLeads, updateMultipleLeadForClaim, updateMultipleLeadStatus, addMultipleLeadLogs, getProjectsData, getCustomerDetails, addLead,getProjectsDataPre,getPersonFromAllotmentPayment,getLeadData,getLeadPersonData,getAllUnitsByProjectIdWingsId,getAllWingsByProjectIdPre,addLeadsReferralTable, getPersonFromAllotmentPaymentbybookingId, updateLeadCpId, checkLeadHasApplicationApiRes, getAllotmentDetailsForLeadSourceChange, getLeadDetailsForFosWalletAssignment,
  getLostLeads, regenerateLead,
  getExpiryRules, createExpiryRule, updateExpiryRule, deleteExpiryRule, getExpiryProtectedStatuses,
  overrideStaleApprovalStatuses
}
